var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { dateFns } from '@/common/utils/ways';
var DatePopover = /** @class */ (function (_super) {
    __extends(DatePopover, _super);
    function DatePopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DatePopover.prototype, "status", {
        get: function () {
            var date = this.date;
            var today = dateFns.changeTime(new Date(), null, true);
            var weekDay = new Date(date).getDay();
            if (!date)
                return '';
            if (date === today || weekDay === 0 || weekDay === 6)
                return 'active';
            if (new Date(date).getTime() < new Date(today).getTime()) {
                return 'old';
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePopover.prototype, "dateStr", {
        get: function () {
            var date = this.date;
            if (!date)
                return '';
            var today = dateFns.changeTime(new Date(), null, true);
            if (date === today) {
                return '今日';
            }
            var curDate = dateFns.changeTime(new Date(date), '.', true);
            if (this.dateType === 15) {
                return curDate.substr(5);
            }
            else {
                if (curDate.substr(8) === '01') {
                    var month = new Date(date).getMonth();
                    return month + 1 + "\u6708";
                }
                return curDate.substr(8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DatePopover.prototype, "dateDetailFormatStr", {
        get: function () {
            var date = this.date;
            return dateFns.changeTime(new Date(date), '.', true) + "(" + dateFns.getWeekDay(date, '周') + ")";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], DatePopover.prototype, "date", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 15,
        })
    ], DatePopover.prototype, "dateType", void 0);
    DatePopover = __decorate([
        Component
    ], DatePopover);
    return DatePopover;
}(Vue));
export default DatePopover;
